<template>
  <v-container fluid>
    <InvestmentInfoCard
        :next-payment="nextPayment"
        :amount-of-investment="amountOfInvestment"
        :currency="investments[0] ? investments[0].currency : null"
        :investments="investments"
    />

    <AdvertisingCarousel />

    <v-row class="mb-2">
      <v-col cols="12" sm="6" class="text-start pb-0">
        <h2 class="body-1">Мои инвестиции</h2>
      </v-col>

      <!-- <v-col cols="6" sm="6" class="d-sm-flex align-center justify-end">
        <PrimaryButton :buttonText="'Открыть новый договор'" />
      </v-col> -->
    </v-row>

    <v-row>
     <InvestmentCard 
      v-for="investment in investments" :key="investment.guid"
      :guid="investment.guid" 
      :contractNumber="investment.contractNumber"
      :currency="investment.currency"
      :repaymentFrequency="investment.repaymentFrequency"
      :dateOfContract="investment.dateOfContract"
      :dateEnd="investment.dateEnd"
      :interestRate="investment.interestRate"
      :dateNextPayout="investment.dateNextPayout"
      :amountByDeal="investment.amountByDeal"
      :amountPeriodic="investment.amountPeriodic"
      :isConfirmed="investment.isConfirmed"
      :isCreatedByAPI="investment.isCreatedByAPI"
      />
    </v-row>
  </v-container>
</template>

<script>
// import PrimaryButton from "@/components/PrimaryButton.vue";
import InvestmentInfoCard from "@/components/InvestmentInfoCard.vue";
import InvestmentCard from "@/components/InvestmentCard.vue";
import { BACKEND_API_ENDPOINT } from "@/api";
import axios from 'axios';
import { jwtDecoded } from "@/helpers";
import AdvertisingCarousel from "@/components/AdvertisingCarousel.vue";

export default {
  components: {
    InvestmentCard,
    InvestmentInfoCard,
    AdvertisingCarousel,
    // PrimaryButton,
  },
  data () {
    return {
      amountOfInvestment: 0,
      nextPayment: 0,
      investments: []
    }
  },
  created() {
    this.fetchInvestments();
  },
  methods: {
    async fetchInvestments() {
      const phoneNumber = this.parsePhoneNumberFromJwt();
      const jwtToken = localStorage.getItem('jwtToken');

      if (!phoneNumber) {
        console.error('Ошибка: Номер телефона не найден в JWT.');
        return;
      }

      try {
        const response = await axios.get(BACKEND_API_ENDPOINT + '/retrieve_deals', {
          params: {
            phone_number: phoneNumber
          },
          headers: {
            Authorization: `Bearer ${jwtToken}`
          }
        });

        this.investments = response.data.Result.deals;

        this.amountOfInvestment = this.investments.reduce((amount, investment) => {
          if (!investment.isConfirmed && !investment.isCreatedByAPI) {
            return amount + 0;
          } else {
            return amount + investment.amountByDeal;
          }
        }, 0).replace(/^0+/, '');

        this.nextPayment = this.investments.reduce((interest, investment) => {
          if (!investment.isConfirmed && !investment.isCreatedByAPI) {
            return interest + 0;
          } else {
            return interest + investment.amountPeriodic;
          }
        }, 0).replace(/^0+/, '');

      } catch (error) {
        console.error('Ошибка при получении данных о инвестициях:', error);
      }
    },
    parsePhoneNumberFromJwt() {
      const payload = jwtDecoded();

      if (payload) {
        return payload.userUUID.replace('+996', '')
      }

      return
    }
}
}
</script>